const AppConfig = {
	SECURITY: {
		AUTH: "/auth/token",
		REFRESH: "/auth/token/refresh"
	},
	EVENTS: {
		PAGINATION: {
			PAGE_SIZE: 25
		}
	}
};

export default AppConfig;
